// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__uWJ3V","layout-body":"style_layout-body__19L46"};